/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.

import reactUpdate from 'immutability-helper';
import React from 'react';

import notifications from 'notifications';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import SortableTable from 'ui-library/SortableTable';
import formatDate from 'util/formatDate';
import * as net from 'util/Net';

import ProjectOpenReviews from './ProjectOpenReviews';

/* eslint-disable-next-line @typescript-eslint/unbound-method */
const {defaultColumn} = SortableTable;

const DATE_FORMAT = 'dddd, MMMM D, YYYY, h:mm a';

interface Props {
  organizationId: string;
}

type State = any;

class AdminProjectsDashboard extends React.Component<Props, State> {
  override state: State = {
    projects: [],
    activeProject: null,
  };

  override componentDidMount(): void {
    net
      .getJSON('/1/api/admin/projects/', {organizationId: this.props.organizationId})
      .done((results: any) => {
        this.setState({projects: results.projects});
      })
      .fail(notifications.notifyError);
  }

  setActiveProject = (projectSummary: any): JQueryPromise<void> =>
    net
      .getJSON(`/1/api/admin/projects/${projectSummary.id}`, {organizationId: this.props.organizationId})
      .done((projectDetails: any) => {
        this.setState({activeProject: reactUpdate(projectSummary, {$merge: projectDetails})});
      })
      .fail(notifications.notifyError);

  renderTable = (): JSX.Element => {
    const rows = this.state.projects;
    const columns = [
      defaultColumn('Name', 'name'),
      defaultColumn('Owner', 'owner'),
      defaultColumn('Users', 'users'),
      defaultColumn('Open Reviews', 'openReviews'),
      defaultColumn('Entries Created (Last week)', 'entriesCreatedLastWeek'),
      defaultColumn('Reviews Accepted (Last week)', 'reviewsAcceptedLastWeek'),
      defaultColumn('Last File Created', 'lastEntryCreatedAt', {
        transform(value: moment.MomentInput) {
          return formatDate(value, DATE_FORMAT) || 'N/A';
        },
      }),
    ];

    return (
      <SortableTable
        columns={columns}
        rows={rows}
        onClickRow={this.setActiveProject}
        clickable={true}
        selectable={true}
      />
    );
  };

  renderTraits = (project: any): JSX.Element => {
    const renderTrait = (traitName: any, traitValue: any): JSX.Element => (
      <div>
        <dt>{traitName}</dt>
        <dd className="u-tiny-spacing-bottom">{traitValue}</dd>
      </div>
    );

    return (
      <Row>
        <Col sm={4}>
          <dl>
            {renderTrait('Project', project.name)}
            {renderTrait('Owner', project.owner)}
            {renderTrait('Created At', formatDate(project.createdAt, DATE_FORMAT) || 'N/A')}
          </dl>
        </Col>
        <Col sm={4}>
          <dl>
            {renderTrait('Total Entries', project.numEntries)}
            {renderTrait('Accepted Reviews', project.numReviewsAccepted)}
            {renderTrait('Last File Created', formatDate(project.lastEntryCreatedAt, DATE_FORMAT) || 'N/A')}
          </dl>
        </Col>
        <Col sm={4}>
          <dl>
            {renderTrait('Entries Created (Last week)', project.entriesCreatedLastWeek)}
            {renderTrait('Entries Accepted (Last week)', project.reviewsAcceptedLastWeek)}
          </dl>
        </Col>
      </Row>
    );
  };

  override render(): JSX.Element {
    return (
      <div>
        <h1>Projects Dashboard</h1>
        <Row>
          <Col sm={12}>{this.renderTable()}</Col>
        </Row>
        {this.state.activeProject != null ? (
          <div className="well">
            <h2>
              {`Project Details: ${this.state.activeProject.name}`}
              <a href={this.state.activeProject.url} className="u-tiny-spacing-left">
                <BenchlingIcon icon="link" />
              </a>
            </h2>
            {this.renderTraits(this.state.activeProject)}
            <Row>
              <Col sm={12}>
                <ProjectOpenReviews openReviews={this.state.activeProject.openReviews} />
              </Col>
            </Row>
          </div>
        ) : (
          <div className="well">
            <h5 className="text-center">Select a project for detailed information.</h5>
          </div>
        )}
      </div>
    );
  }
}

export default AdminProjectsDashboard;
